import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as sharedSelectors from '../../shared/reducers/shared.reducer';
import { PurchasesData } from '../../providers/purchases';
import { Utilities } from '../../providers/utilities';

@Component({
  selector: 'purchases-log',
  templateUrl: 'purchases-log.html'
})
export class PurchasesLogComponent implements OnInit, OnDestroy {

  @Input() isPage: boolean = false;

  public logs$: Observable<{}>;
  public logsTmp$: Observable<{}>;
  private clientSubscribe: Subscription;
  public openDetail: number;
  public clientId: string;
  public limitTo: number = 20;

  constructor(
    public navCtrl: NavController,
    private store: Store<{}>,
    private purchaseData: PurchasesData,
    private utilities: Utilities
  ) { }

  ngOnInit() {
    this.clientSubscribe = this.store.select(sharedSelectors.getClientId).subscribe(clientId => {
      if (clientId) {
        this.clientId = clientId;
        this.logsTmp$ = this.purchaseData.getLogsPay(clientId, 'REBUS_LOG', 'list')
          .map(list => list.result)
          .map(list => list.sort((a, b) => {
            a = new Date(a.timestamp);
            b = new Date(b.timestamp);
            return a > b ? -1 : a < b ? 1 : 0;
          }))
          .do(list => this.utilities.consoleDecorator('Logs list', list));

        this.logs$ = this.logsTmp$;
      }
    });
  }

  search(ev) {
    this.logs$ = this.logsTmp$.map((items: any) => items.filter((item) => this.utilities.searchItem(
      ev.target.value,
      item,
      [{ 'transaction': ['id', 'payment_date', 'authorization_code', 'amount', 'status'] }]
    )));
  }

  loadMore(infiniteScroll, list: any[]) {
    if (this.limitTo < list.length) {
      this.limitTo += 10;
      setTimeout(() => {
        infiniteScroll.complete();
      }, 300);
    } else {
      infiniteScroll.enable(false);
    }
  }

  public isOpen(key) {
    return this.openDetail === key;
  }

  public open(key) {
    if (this.openDetail === key) {
      this.openDetail = null;
    } else {
      this.openDetail = key;
    }
  }

  download() {
    this.purchaseData.getAllByClient
  }

  ngOnDestroy() {
    if (this.clientSubscribe) this.clientSubscribe.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/purchases-log/purchases-log.ts